module.exports = __webpack_public_path__ + "img/w_bg.99e1cffd.png";